import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Redirect } from 'react-router-dom';
import { renderRouter, mainRouters } from './routers';
import { AppProvider } from './context/AppContext';
import { loadLang } from './utils/decorators';
import { isMobile } from './utils/helpers';
import Header from './components/Header';
import Footer from './components/Footer';

import './styles.scss';

interface IAppProps {
  currentLocale: string | null;
  location: any;
}

interface IAppState {
  currentLocale: string | null;
}

class App extends Component<IAppProps, IAppState> {
  antLocale: any;

  currentLocale: string | null;

  // static getDerivedStateFromProps(nextProps) {
  //   // 当路由切换时
  //   if (this.props.location !== nextProps.location) {
  //     window.scrollTo(0, 0);
  //   }
  // }

  constructor(props) {
    super(props);
    this.state = {
      currentLocale: this.props.currentLocale
    };
  }

  render() {
    return (
      <AppProvider
        initContextData={{ currentLocale: this.props.currentLocale }}
      >
        <div className={isMobile() ? 'mobile-content' : 'content'}>
          <Router>
            <Header />
            <Switch>
              {renderRouter(mainRouters)}
              <Redirect to="/" />
            </Switch>
            <Footer />
          </Router>
        </div>
      </AppProvider>
    );
  }
}

export default loadLang(App);
